import { Box, type SxProps, type Theme } from '@mui/material'
import type { ReactNode } from 'react'
import { compactLayoutMediaQuery } from '../../ui/theme/layoutBreakpoints'

export const pageHeaderActionButtonSx: SxProps<Theme> = {
  [compactLayoutMediaQuery]: {
    minWidth: 0,
    px: 1,
    '& .MuiButton-startIcon': {
      marginLeft: 0,
      marginRight: 0,
    },
    '& .MuiButton-endIcon': {
      marginLeft: 0,
      marginRight: 0,
    },
  },
}

type PageHeaderActionLabelProps = {
  children: ReactNode
}

const PageHeaderActionLabel = ({ children }: PageHeaderActionLabelProps) => (
  <Box component="span" sx={{ [compactLayoutMediaQuery]: { display: 'none' } }}>
    {children}
  </Box>
)

export default PageHeaderActionLabel
